module.exports = __webpack_public_path__ + "static/media/2017-06-23_36.80adc16f.JPG";